import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import FormControl from '@material-ui/core/FormControl';
import FilledInput from '@material-ui/core/FilledInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import styles from './LoginPage.module.css'
import Api from "../services/Api";
import { useHistory } from 'react-router-dom';
import Shared from '../services/Shared';

export default function LoginPage() {
    const [email, setEmail] = useState('rover@canineu.com');
    const [emailError, setEmailError] = useState(false);
    const [password, setPassword] = useState('R0v3rD0g!');
    const [passwordError, setPasswordError] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const history = useHistory();

    function onLogin(e) {
        e.preventDefault();

        const isEmailInvalid = !email;
        const isPasswordInvalid = !password;

        setEmailError(isEmailInvalid);
        setPasswordError(isPasswordInvalid);

        if (isEmailInvalid || isPasswordInvalid) {
            return;
        }

        Api.postToken(email, password, response => {

            sessionStorage.setItem(Shared.key.token, response.token);
            sessionStorage.setItem(Shared.key.refresh, response.refreshToken);

            Api.getUser( user => {
    
                sessionStorage.setItem(Shared.key.user, JSON.stringify(user));
                console.log("logged in")
                history.push(Shared.path.menu);
            });
        });
    }

    return (
        <div className={styles.flexCol}>
            <div><img className={styles.img} alt="canine-u" src={Shared.assets + "/canine_u.png"}/></div>
            <div><img className={styles.img} alt="peace" src={Shared.assets + "/peace.jpg"}/></div>
            <form id="login-form" onSubmit={onLogin} className={styles.fields}>
                <div className={styles.field}>
                    <TextField label="Email" variant="filled" helperText={emailError ? 'Required' : ' '} onChange={e => setEmail(e.target.value)} error={emailError} value={email}/>
                </div>
                <div className={styles.field}>
                    <FormControl>
                        <InputLabel className='MuiInputLabel-filled' htmlFor="pw" error={passwordError}>Password</InputLabel>
                        <FilledInput
                            id="pw"
                            type={showPassword ? 'text' : 'password'}
                            onChange={e => setPassword(e.target.value)}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={e => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            error={passwordError}
                            value={password}
                        />
                        <FormHelperText error={passwordError}>{passwordError ? 'Required' : ' '}</FormHelperText>
                    </FormControl>
                </div>
            </form>
            <div>
                <Button form="login-form" type="submit" variant="contained" color="primary">Log in</Button>
            </div>
        </div>
    )
}